/**
 * @fileoverview Signed-in user display helpers.
 * @description Small formatting helpers derived from AuthUser fields, shared by anywhere that
 * renders an avatar for the signed-in user (DashboardHeaderUserMenu, ProfilePage) — there is no
 * separate "display name" field anywhere in this app's identity contract, only email.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

/**
 * @description Builds a two-letter avatar initial from an email address (the part before "@"):
 * the first letter of each of its first two dot/underscore/hyphen-separated segments (e.g.
 * "ava.patel@..." -> "AP"), or its first two characters when there's only one segment (e.g.
 * "hrishikesh@..." -> "HR").
 * @param {string} email - The user's email address.
 * @returns {string} Up to two uppercase initials.
 */
export function initialsFromEmail(email: string): string {
  const localPart = email.split('@')[0] ?? ''
  const segments = localPart.split(/[._-]+/).filter(Boolean)

  const initials =
    segments.length > 1
      ? `${segments[0]?.[0] ?? ''}${segments[1]?.[0] ?? ''}`
      : localPart.slice(0, 2)

  return initials.toUpperCase()
}
